import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToast } from '../../../shared/toastMessages/toastProvider';

import {
    Typography,
    Box,
    Stack,
} from '@mui/material';

import TableComponent from "../../../shared/table/table";
import getApiData from '../../../../hooks/apiRequests/getRequest';
import { normalizePageParam } from '../../../../hooks/pagination';

import {theme} from '../../../../configs/theme';
import css from '../../../../styles/portal/main.module.css';


const ManageEmails = () =>{
    const [searchParams, setSearchParams] = useSearchParams();
    const [data, setData] = useState();
    const [progress, setProgress] = useState(false);
    const navigate = useNavigate();
    const { showToast } = useToast();
    const query = searchParams.get('query') || '';
    const page = normalizePageParam(searchParams.get('page'));

    useEffect(() => {
        const fetchData = async () => {
          setProgress(true);
          try {
            const response = await getApiData(`/Emails/List?Search_filter=${encodeURIComponent(query)}&page_number=${page}`);
            if (!response?.data) {
              throw new Error('Empty emails list response');
            }
            setData(response.data);
          } catch (error) {
            console.error("Error fetching data:", error);
            showToast("Failed to load data", "error");
          } finally {
            setProgress(false);
          }
        };
    
        fetchData();
    }, [query, page, showToast]);

    const newpage = async (nextPage, search) => {
        setSearchParams({
            query: search || "",
            page: normalizePageParam(nextPage),
        });
    };

    const handleOpen = () =>{
        navigate(`/Portal/Emails/Create`);
    };

    const handleNav = (id) =>{
        localStorage.setItem(
            "lastEmailListUrl",
            window.location.pathname + window.location.search
        );
        navigate(`/Portal/Emails/Edit/${id}`);
    };

    return(
        <Box sx={{ px: { md: 2 }, pb: 3 }}>
          <Stack spacing={0.5} sx={{ py: 2 }}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: 'black' }}>
              Manage Emails
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Browse, search, and open email campaigns to review their content and delivery settings.
            </Typography>
          </Stack>

          <div className={css.container}>
              <TableComponent
                  apiData={data} 
                  progress={progress}
                  noResults={!progress && Array.isArray(data?.data) && data.data.length === 0} 
                  columnNames={{
                      title: "Title",
                      groups: "Mailing Lists",
                      status: "Status",
                      release_time: "Release Time",
                      time_created: "Time Created",
                  }}
                  hiddenColumns={[
                      'body',
                      'basic_body'
                    ]}
                  handleAdd={handleOpen}
                  handleOpen={handleNav}
                  theme={theme}
                  newpage={newpage}
                  mailingTable={false}
                  query={query}
                  pageNumber={page}
              />
          </div>
        </Box>
    );
};

export default ManageEmails;
